import { render, staticRenderFns } from "./BlockTitle.vue?vue&type=template&id=155f78f7&scoped=true"
import script from "./BlockTitle.vue?vue&type=script&lang=ts"
export * from "./BlockTitle.vue?vue&type=script&lang=ts"
import style0 from "./BlockTitle.vue?vue&type=style&index=0&id=155f78f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155f78f7",
  null
  
)

export default component.exports